import { render, staticRenderFns } from "./InsuranceBridgeRecipe.vue?vue&type=template&id=38a6ec7b&"
import script from "./InsuranceBridgeRecipe.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports